export default __webpack_public_path__ + "static/media/bikeDown.c1c77951.mp4";